import React, { Fragment } from 'react';
import { Container } from 'react-bootstrap';
import HeaderLogged from '../../../components/header_logged'
import Footer from '../../../components/footer'
import Head from '../../../components/head';
import LicitacaoLogged from '../../../components/auth/licitacao'

function LicitacaoLoggedScreen() {
        return (
            <Fragment>
                <Head titulo="Módulo de Licitação" />
                <HeaderLogged />
                <Container>
                   <LicitacaoLogged />
                </Container>
                <Footer />
            </Fragment>
        );
}

export default LicitacaoLoggedScreen;